import { Action } from 'redux';

import { REQUEST_API } from 'src/constants';
import { REQUEST_API_LATEST, RESET_REPORTS_LIST } from './actions';

export interface BaseAction extends Action<string> {
  [extraProps: string]: unknown;
}

export const CLEAR_API_KEYS = 'CLEAR_API_KEYS';
export const CLEAR_API_ERROR = 'CLEAR_API_ERROR';

export interface UrlFormatParams {
  _office_?: string;
  _report_?: string;
  _section_?: string;
  _period_?: string;
  _id_?: string | number;
  _year_?: string | number;
  _cpb_key_?: string;
  _type_?: string;
  _comment_?: string;
  _reply_?: string;
}

export interface IRequestParams {
  data?: any;
  method?: string;
  url_format?: UrlFormatParams;
  storage_key?: string;
  success_actions?: Action[];
}

export interface RequestAPIPayload {
  dataKey: string;
  params: IRequestParams;
}

export interface RequestAPIAction extends RequestAPIPayload, BaseAction {
  type: typeof REQUEST_API;
}

export interface RequestAPILatestParams {
  url_format: UrlFormatParams;
}

export interface RequestAPILatestAction extends BaseAction {
  type: typeof REQUEST_API_LATEST;
  dataKey: string;
  params: RequestAPILatestParams;
}

export interface ClearApiKeysAction extends BaseAction {
  type: typeof CLEAR_API_KEYS;
  dataKeys: string[];
}

export interface ClearApiErrorAction extends BaseAction {
  type: typeof CLEAR_API_ERROR;
  dataKey: string;
}

export interface ResetReportsListAction extends BaseAction {
  type: typeof RESET_REPORTS_LIST;
}
